
import Vue from 'vue'

import imageModal from '@/components/project/imageModal.vue'
Vue.component('imageModal', imageModal)